import { initInlet as Inlet } from 'aem-libs/src/initInlet'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import InletWrapper from 'aem-libs-react-ts/src/components/InletWrapper'
import AppSpinner from 'aem-libs-react-ts/src/services/AppSpinner'
import StaticParams from 'aem-libs-react-ts/src/services/StaticParams'
import UserTracking from 'aem-libs-react-ts/src/services/UserTracking'
import { IContext } from 'aem-libs-react-ts/src/store/Store'

import App from './App'

import './i18n'

import { makeStore } from './store/createStore'

declare var WEBPACK_INLET_VERSION: string
declare var WEBPACK_INLET_CONFIG: any

const appName = 'RAemRegularInvestmentCalculator'

const inlet = Inlet(
  appName,
  /* global WEBPACK_INLET_VERSION */ WEBPACK_INLET_VERSION,
)

const appElement = inlet.element.insertAdjacentElement(
  'afterbegin',
  document.createElement('div'),
)

const init: IContext = {
  appName,
  appSpinner: AppSpinner(inlet.element),
  error: null as any,
  paramsDynamic: {},
  paramsFile: /* global WEBPACK_INLET_CONFIG */ WEBPACK_INLET_CONFIG,
  paramsStatic: StaticParams(inlet.element),
  userTracking: UserTracking(appName),
}

ReactDOM.render(
  <InletWrapper>
    <Provider store={makeStore(init)}>
      <App />
    </Provider>
  </InletWrapper>,
  appElement,
)
